import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78bfc52c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "solar-packages"
}
const _hoisted_2 = { class: "solar-packages__container" }
const _hoisted_3 = { class: "h4 solar-packages__title" }
const _hoisted_4 = { class: "solar-packages__article-wrapper" }
const _hoisted_5 = { class: "solar-packages__description" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "solar-packages-info__text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "solar-packages__next-button-icon icon icon-arrow-right" }, null, -1))
const _hoisted_9 = { class: "solar-package__img-container" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "solar-package__title" }
const _hoisted_12 = { class: "solar-package__details" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_CarouselSolarPackages = _resolveComponent("CarouselSolarPackages")!

  return (_ctx.pageContent && _ctx.enableSimplePackagesPage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.pageContent.title), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.pageContent.description), 1)
          ]),
          _createVNode(_component_RadioGroup, {
            modelValue: _ctx.solarPackage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.solarPackage) = $event)),
            options: _ctx.packageOptions
          }, null, 8, ["modelValue", "options"]),
          _createElementVNode("a", {
            class: "solar-packages-info",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPackagesModal = true))
          }, [
            _createElementVNode("img", {
              src: require('@/assets/images/question-mark.svg'),
              class: "solar-packages-info__icon"
            }, null, 8, _hoisted_6),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.pageContent.moreInfoCopy), 1)
          ]),
          _createVNode(_component_AppButton, {
            class: "solar-packages-info__next-button",
            disabled: !_ctx.solarPackage,
            "full-width": "",
            onClick: _ctx.next
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.pageContent.nextButtonCopy), 1),
              _hoisted_8
            ], undefined, true),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _createVNode(_component_Modal, {
          "is-modal-open": _ctx.showPackagesModal,
          "is-full-screen": "true",
          onCloseModal: _ctx.togglePackageModal
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageContent.packages, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.packageId,
                class: "solar-package"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    class: "solar-package__img",
                    src: option.image.filename
                  }, null, 8, _hoisted_10)
                ]),
                _createElementVNode("h4", _hoisted_11, _toDisplayString(option.title), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(option.aboutPackage), 1)
              ]))
            }), 128))
          ]),
          cancelButton: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.pageContent.moreInfoCloseButtonCopy), 1)
          ]),
          _: 1
        }, 8, ["is-modal-open", "onCloseModal"])
      ]))
    : (_openBlock(), _createBlock(_component_CarouselSolarPackages, {
        key: 1,
        onGoForward: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('go-forward')))
      }))
}